import { createSlice } from "@reduxjs/toolkit";
import { getUserProfileThunk } from "store/thunk/kyp.thunk";
import { createUserThunk, verifyOtpThunk } from "store/thunk/main.thunk";

interface initialStateProps {
  loading: boolean;
  error: string | null;
  currentUserDetails: any;
  loginLoading: boolean;
  otpLoading: boolean;
}

const initialState: initialStateProps = {
  loading: false,
  error: null,
  currentUserDetails: "",
  loginLoading: false,
  otpLoading: false
};

const mainSlice = createSlice({
  name: "Main Slice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createUserThunk.pending, (state) => {
        state.loginLoading = true;
      })
      .addCase(createUserThunk.fulfilled, (state, action) => {
        state.loginLoading = false;
        state.currentUserDetails = action.payload?.data?.userObj;
        state.error = null;
      })
      .addCase(createUserThunk.rejected, (state, action) => {
        state.loginLoading = false;
        state.error = action.error.message ?? "An error occurred";
      })
      .addCase(verifyOtpThunk.pending, (state) => {
        state.otpLoading = true;
      })
      .addCase(verifyOtpThunk.fulfilled, (state, action) => {
        state.otpLoading = false;
        sessionStorage.setItem("userToken", JSON.stringify(action.payload.data?.token));
        state.error = null;
      })
      .addCase(verifyOtpThunk.rejected, (state, action) => {
        state.otpLoading = false;
        state.error = action.error.message ?? "An error occurred";
      })

      .addCase(getUserProfileThunk.pending, (state) => {
        state.loginLoading = true;
      })
      .addCase(getUserProfileThunk.fulfilled, (state, action) => {
        state.loginLoading = false;
        state.currentUserDetails = action.payload?.data;
        state.error = null;
      })
      .addCase(getUserProfileThunk.rejected, (state, action) => {
        state.loginLoading = false;
        state.error = action.error.message ?? "An error occurred";
      });
  }
});

export default mainSlice.reducer;
